import protoRoot from "../proto-root";

function create({
  id,
  start,
  duration,
  eventType,
  fileName,
  fileRelatedLength,
  fileRelatedDuration,
  payload,
  referenceId
}) {
  const ActivityLogEvent = protoRoot.lookupType(`comm.ActivityLogEvent`);
  const ActivityLogEventType = protoRoot.lookupEnum("ActivityLogEventType");
  const StringValue = protoRoot.lookupType("StringValue");
  const Int64Value = protoRoot.lookupType("comm.Int64Value");

  return ActivityLogEvent.create({
    id,
    start,
    duration,
    eventType: ActivityLogEventType.values[eventType],
    ...(fileName && { fileName: StringValue.create({ value: fileName }) }),
    fileRelatedLength,
    fileRelatedDuration,
    payload,
    ...(referenceId && {
      referenceId: Int64Value.create({ value: referenceId })
    })
  });
}

export default {
  create
};

// message ActivityLogEvent {
//   reserved 2;
//   int64 id = 1;                        // event id unique to monitoring
//   int64 start = 10;                    // in milliseconds - relative from start of monitoring
//   int64 duration = 11;                 // in milliseconds
//   ActivityLogEventType eventType = 12;
//   StringValue fileName = 13;
//   int64 fileRelatedLength = 14;
//   int64 fileRelatedDuration = 16;
//   string payload = 15;                 // for other event related data (not used now)
//   Int64Value referenceId = 17;         // possible relation of this event to another event
// }
